export default {
    name: null,
    description: null,
    url: null,
    project: null,
    products: []
}
